import pick from 'lodash/pick';
import get from 'lodash/get';

export function formatCountries(countries) {
  return countries
    .filter(({ availability: { order } = {} }) => order)
    .map(({ alpha2, label }) => ({
      value: alpha2,
      data: label.toLowerCase(),
    }))
    .sort((a, b) => (a.data > b.data ? 1 : -1));
}

export function formatAccountDetails(accountDetails) {
  return {
    ...pick(accountDetails, [
      'additionalInformation',
      'allowNews',
      'email',
      'firstName',
      'languageId',
      'lastName',
      'partner',
      'paymentCardNumber',
      'paymentExpirationDate',
      'paymentHolder',
      'paymentType',
      'smartCardId',
      'status',
    ]),
    addressCity: get(accountDetails, 'addresses.0.addressCity', ''),
    addressCountry: get(accountDetails, 'addresses.0.addressCountry', ''),
    addressStreet: get(accountDetails, 'addresses.0.addressStreet', ''),
    addressZip: get(accountDetails, 'addresses.0.addressZip', ''),
    phoneNumber: get(accountDetails, 'phoneNumbers.0.number', ''),
    shareEmail: get(accountDetails, 'additionalInformation.shareEmail', false),
    username: get(accountDetails, 'login', ''),
  };
}
